declare global {
  interface Window {
    dataLayer: any;
  }
}

const trackCartProductProtectionWhatIsCovered = data => {
  const event = 'cart_product_protection_whats_covered'

  const logData = {
    event,
    ...data,
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(logData)
}

export default trackCartProductProtectionWhatIsCovered
